import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {DndProvider} from 'react-dnd-multi-backend';
import {HTML5toTouch} from 'rdndmb-html5-to-touch';
import { gameUiTexts } from 'data/ui-texts';
import {scenariosData} from 'data/scenarios-data';
import {customAreas} from 'data/custom-areas/custom-areas';
import Button from 'components/ui/button/button';
import Area from 'components/area-hub/area';
import Case from 'components/area-hub/case';
import PopupCaseFile from 'components/ui/popup-case-file/popup-case-file';
import './game.scss';

const Game = ({ game, schoolData, group, groups, scenarioId, handleGoToPage, updateGroup, updateBackground }) => {
	/* Get scenario data */
	const scenarioData = Object.assign({}, scenariosData[scenarioId]);

	/* Get game data (depends on scenarioId) */
	const gamePagesData = Object.assign({}, scenarioData.gamePagesData);

	if (
		scenarioId !== 'game1' &&
		schoolData && 
		schoolData.customAreaId &&
		customAreas.some((area) => {return area.id === schoolData.customAreaId;})
	) {
		const customArea = customAreas.find((area) => {return area.id === schoolData.customAreaId;});
		scenarioData.tasksData[customArea.id] = customArea.tasksData;
		if (!gamePagesData.areaHub.routes.some((route) => {return route.id === customArea.id;})) {
			gamePagesData.areaHub.routes.push({
				id: customArea.id,
				name: customArea.name,
				pageId: customArea.id
			});
		}

		gamePagesData[customArea.id] = {
			component: Area,
			caseComponent: Case,
			id: customArea.id,
			name: customArea.name,
			background: customArea.background,
			infoTitle: customArea.infoTitle,
			infoText: customArea.infoText,
			routes: customArea.routes
		};
		scenarioData.gamePagesData = gamePagesData;
	}
	
	/* Current page and its data */
	const [pageId, setPageId] 	= useState('areaHub');
	const pageData = gamePagesData[pageId];
	let CurrentComponent = pageData.component; // areaHub, areas, cases, 
	let infoTitle = pageData.infoTitle;
	let infoText = pageData.infoText;
	const routes = pageData.routes;
	let id = null;
	const [casesId, setCasesId] = useState(null);

	/* if the current page is not areahub get id and possible case data */
	if (pageId !== 'areaHub') {
		id = pageData.id;
		if (casesId !== null) {
			CurrentComponent = pageData.caseComponent;
		}
	}

	useEffect(() => {
		// Set background image id
		updateBackground(pageData.background, scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pageId]);
	
	/* Popup for case file */
	const [popupFileData, setPopupFileData] = useState(null);

	return (
		<div className="Game">
			<DndProvider options={HTML5toTouch}>
				{CurrentComponent && 
					<CurrentComponent 
						setPageId={setPageId}
						infoTitle={infoTitle}
						infoText={infoText}
						routes={routes}
						id={id}
						game={game}
						scenarioData={scenarioData}
						schoolData={schoolData}
						scenarioId={scenarioId}
						group={group}
						groups={groups}
						setCasesId={setCasesId}
						casesId={casesId}
						updateGroup={updateGroup}
						setPopupFileData={setPopupFileData}
					/>
				}

				{pageId === 'areaHub' &&
					<div className="Game-backBtn">
						<Button
							text={gameUiTexts.backBtn}
							classes={['backBtnGame', scenarioId, 'responsive']}
							onClick={() => {handleGoToPage('landing');}}
						/>
					</div>
				}
			</DndProvider>

			{popupFileData && <PopupCaseFile 
				popupData={popupFileData}
				setPopupData={setPopupFileData}
			/>}
		</div>
	);
};

Game.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	schoolData: PropTypes.object,
	game: PropTypes.object.isRequired, 
	group: PropTypes.object.isRequired,
	groups: PropTypes.array.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	updateGroup: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired,
};

export default Game;